// extracted by mini-css-extract-plugin
module.exports = {"meta_brand":"#ff6900","meta_background":"#333333","bartosjiri":"Bartosjiri-module--bartosjiri--Ss2Sq"};